import { actions } from "utils/helpers";
import { toast } from "react-hot-toast";
import { UNAUTHORIZED } from "constants";
import Table from "components/Table/Table";
import { useDispatch, useSelector } from "react-redux";
import { selectAuthUser } from "features/auth/authSlice";
import Pagination from "components/Pagination/Pagination";
import { setNavbarTitle } from "features/navbar/navbarSlice";
import { useNavigate, useSearchParams } from "react-router-dom";
import TableSkeleton from "components/Table/TableSkeleton/TableSkeleton";
import React, { Fragment, useCallback, useEffect, useState } from "react";
import {
  useGetSipProfilesQuery,
  useDeleteSipProfileMutation,
} from "features/sip_profile/sipprofileApiSlice";

import cardStyles from "styles/modules/Card.module.scss";

const SipProfiles = ({ label }) => {
  const [searchParams] = useSearchParams();

  const {
    currentData,
    isFetching: isLoading,
    isError,
    error
  } = useGetSipProfilesQuery(searchParams.toString());

  const [deleteSipProfile] = useDeleteSipProfileMutation();

  const authUser = useSelector(selectAuthUser);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(setNavbarTitle("Sip Profiles"));
  }, [dispatch]);

  const [errorDisplayed, setErrorDisplayed] = useState(false);

  useEffect(() => {
    if (isError && !errorDisplayed) {
      toast.error(error?.message || "Could not load sip profiles, try refreshing the page");
      setErrorDisplayed(true);
    }
  }, [isError, error, errorDisplayed]);


  const onEditBtnHandler = useCallback(
    (id, callFn = false) => {
      if (authUser?.actions[label].includes(actions.view)) {
        if (callFn) {
          navigate(`/sip_profiles/${id}`);
        }

        return "";
      }

      return UNAUTHORIZED;
    },
    [authUser?.actions, label, navigate]
  );

  const onDeleteBtnHandler = useCallback(
    async (id, callFn = false) => {
      if (authUser?.actions[label].includes(actions.delete)) {
        if (callFn) {
          await deleteSipProfile(id).unwrap();
        }

        return "";
      }

      return UNAUTHORIZED;
    },
    [authUser?.actions, deleteSipProfile, label]
  );

  return (
    <div>
      <div className={cardStyles.menu}>
        <h3>Showing data for sip profiles</h3>
      </div>
      {isLoading ? (
        <TableSkeleton />
      ) : (
        <Fragment>
          <Table
            data={currentData}
            onEdit={onEditBtnHandler}
            onDelete={onDeleteBtnHandler}
          />
          <Pagination totalCount={currentData?.size} />
        </Fragment>
      )}
    </div>
  );
};

export default SipProfiles;
